<template>
  <div>
    <!-- -->
    <h3>{{ title }}</h3>
    <vue-picture-swipe
      :options="{
        shareEl: false,
        index: 0,
        history: false,
        focus: false,
        showHideOpacity: true,
        clickToCloseNonZoomable: true,
        showAnimationDuration: 0,
        hideAnimationDuration: 0,
        tapToClose: true,
        spacing: 0,
        loop: false,
        preload: [1, 5],
      }"
      :items="items"
    ></vue-picture-swipe>
  </div>
</template>
<script>
import { isNullOrEmpty } from "./Utils";
import { getAlbum } from "./UtilsAlbum";

export default {
  name: "Album",
  props: {
    baseUrl: String,
    albumUrl: String,
  },
  methods: {},
  async created() {
    console.log("Open: " + this.baseUrl + " -> " + this.albumUrl);
    const startTime = new Date().getTime();

    var me = this;
    if (isNullOrEmpty(this.albumUrl)) {
      me.title = "Kein Album gefunden.";
    } else {
      try {
        var cb = function (title, item, sort, items) {
          me.title = title;
          if (item) {
            me.items.push(item);
          } else if (sort) {
            me.items.sort(function (p1, p2) {
              return p1.idx > p2.idx ? 1 : -1;
            });
            console.log(
              "Loading album in " + (new Date().getTime() - startTime)
            );
          } else if(items) {
            me.items = items;
            // me.title = album.title;
          } 
        };
        getAlbum(this.baseUrl, this.albumUrl, cb);
      } catch (e) {
        this.title = "Kann Album nicht laden: " + e.message;
      }
    }
  },
  data() {
    return {
      title: "Lade Album ...",
      items: [],
    };
  },
};
</script>
<style scoped>
</style>